import selectors from '../../../../rootSelectors';
import { showQuestion, showSegment } from '../../../rctActions';
import {
    enableDownButton, activateNextButton, highlightDownButton, unblockScreen,
} from '../../../../common/screen/screenActions';
import { GENERAL_AUDIO_DELAY } from '../../../../constants/time';
import { MODEL } from '../../../../constants/assessmentItemType';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const FLUENCY_AUDIO = RCT_AUDIO_INSTRUCTIONS.FLUENCY;

export const narrateDirectionsScript = (delay = GENERAL_AUDIO_DELAY) => (dispatch) => dispatch(playAvatarAudio([FLUENCY_AUDIO.directionInstruction], delay));

export const narrateModelScript = (delay = GENERAL_AUDIO_DELAY) => (dispatch) => dispatch(playAvatarAudio(FLUENCY_AUDIO.modelInstruction, delay))
    .then(() => {
        dispatch(setAvatarInstructions(FLUENCY_AUDIO.modelInstructionReplay));
        dispatch(highlightDownButton());
        dispatch(enableDownButton());
    });

export const narrateQuestionScript = () => (dispatch) => {
    dispatch(setAvatarInstructions(FLUENCY_AUDIO.modelAnswerInstruction));
    return dispatch(playAvatarAudio(FLUENCY_AUDIO.modelAnswerInstruction));
};

export const narrateNextButtonScript = () => (dispatch) => dispatch(playAvatarAudio(FLUENCY_AUDIO.modelComplete));

export const showNextSegment = () => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasNextSegment(state, MODEL)) {
        const nextSegmentIndex = selectors.getActiveSegmentIndex(state) + 1;
        dispatch(showSegment(nextSegmentIndex));
    }
};

export const showNavigationButton = () => (dispatch, getState) => {
    const state = getState();
    if (!selectors.hasNextSegment(state, MODEL)) {
        dispatch(setAvatarInstructions(FLUENCY_AUDIO.clickOk));
        dispatch(activateNextButton());
        return dispatch(narrateNextButtonScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    }
    dispatch(enableDownButton());
    dispatch(unblockScreen());
    return Promise.resolve();
};

export const showNextElementOnDownButtonClick = () => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasQuestion(state, MODEL)) {
        dispatch(showQuestion());
    } else {
        dispatch(showNextSegment());
    }
};
